var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useState } from 'react';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
import ControlsMinus from '../private/icons/ControlsMinus';
import GenericCheckAlternative from '../private/icons/GenericCheckAlternative';
const Checkbox = forwardRef((_a, ref) => {
    var { ariaLabel, label, bgColor = 'bg-piccolo', className, indeterminate } = _a, rest = __rest(_a, ["ariaLabel", "label", "bgColor", "className", "indeterminate"]);
    const [isChecked, setIsChecked] = useState(rest.checked || false);
    useEffect(() => {
        if (typeof rest.checked !== undefined && rest.checked !== isChecked)
            setIsChecked(!!rest.checked);
    }, [rest.checked]);
    const ariaLabelValue = label
        ? undefined
        : ariaLabel
            ? ariaLabel
            : rest['aria-label']
                ? rest['aria-label']
                : rest.name
                    ? rest.name
                    : 'Checkbox';
    return (React.createElement("label", { htmlFor: rest.id, className: mergeClassnames('relative flex items-center gap-2 text-moon-14 text-bulma cursor-pointer', rest.disabled && 'opacity-60 cursor-not-allowed select-none', rest.readOnly && 'cursor-not-allowed select-none') },
        React.createElement("input", Object.assign({ id: rest.id, disabled: rest.disabled, readOnly: rest.readOnly, "aria-label": ariaLabelValue, ref: ref, className: "peer appearance-none h-6 w-6 outline-none align-top select-none", type: "checkbox", "aria-checked": indeterminate ? 'mixed' : isChecked, checked: isChecked, onClick: (e) => {
                var _a;
                if (rest.disabled || rest.readOnly) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                if (rest.onClick)
                    rest.onClick(e);
                setIsChecked((_a = e === null || e === void 0 ? void 0 : e.currentTarget) === null || _a === void 0 ? void 0 : _a.checked);
            }, onChange: rest.onChange ? rest.onChange : (e) => { } }, rest)),
        React.createElement("span", { className: mergeClassnames('absolute top-1 start-1 flex w-4 h-4 items-center justify-center shadow-[0_0_0_1px_inset] transition-colors text-moon-16 rounded-moon-s-xs shadow-trunks peer-checked:shadow-none text-goten', (isChecked || indeterminate) && bgColor, indeterminate && 'shadow-none', className && className), "aria-hidden": "true" }, indeterminate ? (React.createElement(ControlsMinus, { className: mergeClassnames('transition-opacity opacity-100') })) : (React.createElement(GenericCheckAlternative, { className: mergeClassnames('transition-opacity', isChecked ? 'opacity-100' : 'opacity-0') }))),
        label));
});
export default Checkbox;
